export default __webpack_public_path__ + "static/how-it-works-f6db4419c0a906977951f68b27f1de36.png";